import { ReasignacionPcfViewModel } from '../../../_exportacion/solicitudes/inspecciones/inspeccionesEx.types';
import { PagingResultsViewModel } from '../../../core/_infrastructure/types/common';

export class SolicitudExItemResultsViewModel extends PagingResultsViewModel {
    public ResultList: SolicitudExItemViewModel[];
}

export class SolicitudExItemViewModel {
    public Id: number;
    public IdUsuarioSolicitante: number;
    public IdPuntoInspeccion: number;
    public FechaEnvio: Date;
    public HoraEnvio: Date;
    public Codigo: string;
    public NumeroCertificado: string;
    public IdIdioma: number;
    public AplicaTasa: boolean;
    public EsPrevia: boolean;
    public TieneAlegacion: boolean;
    public IdFormatoSolicitudEx: number;
    public EsEphyto: boolean;
    public DescripcionPuntoInspeccion: string;

    public IdTipoSolicitudEx: number;
    public IdEstadoSolicitudEx: number;
    public IdEstadoCertificadoFitoEx: number;

    public DescripcionTipoSolicitudEx: string;
    public CodigoTipoSolicitudEx: string;
    public DescripcionEstadoSolicitudEx: string;
    public DescripcionEstadoCertificadoFitoEx: string;
}

export class SolicitudExViewModel {
    constructor() {}

    public Id: number;
    public Codigo = '';
    public NumeroCertificado = '';
    public IdPuntoInspeccion = 0;
    public IdTipoSolicitudEx = 0;
    public IdEstadoSolicitudEx = 0;
    public FechaEnvio: Date;
}

export class EditSolicitudExPcfViewModel {
    constructor() { }

    Id: number;
    Codigo: string;
    NumeroCertificado: string;
    IdEstadoSolicitudEx: number;
    IdTipoSolicitudEx: number;
    FechaEnvio: Date;
    IdPuntoInspeccion: number;
    IdUbicacion: number;
    IdInstalacionAutorizada: number;
    IdIntervaloHoras: number;

}
